import { Loader } from '@insify/design-system/components';
import { ChevronRight } from '@insify/design-system/icons';
import { textSm, textSmSemibold } from '@insify/design-system/typography';
import { type OptionRenderPropArg, type SearchResultItem, useSearch } from '@insify/funnel-components';
import { ContentContextWrapper, TrackedButton } from '@objectiv/tracker-react';
import clsx from 'clsx';

import * as styles from './SearchItem.module.css';

import type { RegisteredCompany } from '../../../models/company';

type Props<OptionType> = OptionRenderPropArg & SearchResultItem<OptionType>;

export const SearchItem = ({ item, active, selected: isSelected }: Props<RegisteredCompany>) => {
  const { mapOptionToId, isSubmitting } = useSearch();
  const id = mapOptionToId(item);
  return (
    <ContentContextWrapper id={id}>
      <TrackedButton objectiv={{ id: 'add' }} type='button' className={clsx(styles.container, active && styles.active)}>
        <div translate='no'>
          <span className={clsx(textSmSemibold, styles.name)}>{item.name?.toLocaleLowerCase()}</span>
          <span className={clsx(textSm, styles.location)}>
            {item.address?.postalCode?.toLocaleLowerCase()} {item.address?.city?.toLocaleLowerCase()}
          </span>
        </div>
        {isSubmitting && isSelected ? <Loader className={styles.icon} /> : <ChevronRight className={styles.icon} />}
      </TrackedButton>
    </ContentContextWrapper>
  );
};
